import type { IUser } from "@/modules/auth/types";
import type { Page } from "@/modules/pages/types";
import { isSuperAdmin } from "@/modules/widgets/utils/permissions";

export function canViewPage(page: Page, user: IUser | null): boolean {
    if (!user) {
        return false;
    }

    if (isSuperAdmin(user)) {
        return true;
    }

    if (page.publishedToAll) {
        return true;
    }

    if (page.createdBy && String(page.createdBy) === user.userId) {
        return true;
    }

    return false;
}

export function canEditPage(page: Page, user: IUser | null): boolean {
    if (!user) {
        return false;
    }

    if (isSuperAdmin(user)) {
        return true;
    }

    if (page.createdBy && String(page.createdBy) === user.userId) {
        return true;
    }

    return false;
}

export function canDeletePage(page: Page, user: IUser | null): boolean {
    return canEditPage(page, user);
}
